ixModuleRouting("impactx.filter", {
    "/userfilterlist": {
        template: "<ixa-user-filter-list></ixa-user-filter-list>",
        process: "EditProfile",
        workspace: "shop",
    },
});
